import React, { useContext, useEffect, useState } from 'react';
import { Table, Segment, Label, Loader, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../app/layout/App';

const ACTION_COLOR = { UPDATE: 'blue', DELETE: 'red', VALIDATE: 'green' };

const AuditPage = () => {
  const { state } = useContext(UserContext);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('/api/audit', {
      headers: { Authorization: `Bearer ${state.token}` },
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Erru');
        return data;
      })
      .then((data) => { setRows(data); setLoading(false); })
      .catch((err) => { setError(err.message); setLoading(false); });
  }, [state.token]);

  if (loading) return <Loader active content='Loading...' />;
  if (error) return <Message negative><p>{error}</p></Message>;

  return (
    <Segment>
      <h3>Audit log ({rows.length})</h3>
      {rows.length === 0 ? (
        <p>No activity recorded yet.</p>
      ) : (
        <Table celled striped compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Action</Table.HeaderCell>
              <Table.HeaderCell>Case</Table.HeaderCell>
              <Table.HeaderCell>User</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {rows.map((r) => (
              <Table.Row key={r.id}>
                <Table.Cell>
                  {new Date(r.changed_at).toLocaleString('fr-FR')}
                </Table.Cell>
                <Table.Cell>
                  <Label color={ACTION_COLOR[r.action] || 'grey'} size='small'>
                    {r.action}
                  </Label>
                </Table.Cell>
                <Table.Cell>
                  {r.action !== 'DELETE' ? (
                    <Link to={`/cases/${r.project_id}`}>
                      {r.project_name || `#${r.project_id}`}
                    </Link>
                  ) : (
                    <span style={{ color: '#999' }}>
                      {r.project_name || `#${r.project_id}`} (supprimé)
                    </span>
                  )}
                </Table.Cell>
                <Table.Cell>{r.user_email}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Segment>
  );
};

export default AuditPage;
